"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
var shared_1 = require("@formily/shared");
var field_1 = require("./models/field");
var virtual_field_1 = require("./models/virtual-field");
exports.createFormExternals = function (internals) {
    var options = internals.options, init = internals.init, env = internals.env, form = internals.form, heart = internals.heart, graph = internals.graph, validator = internals.validator, upload = internals.upload, hostUpdate = internals.hostUpdate, afterUnmount = internals.afterUnmount, nextTick = internals.nextTick, isHostRendering = internals.isHostRendering, getDataPath = internals.getDataPath, getFormValuesIn = internals.getFormValuesIn, getFormInitialValuesIn = internals.getFormInitialValuesIn, deleteFormValuesIn = internals.deleteFormValuesIn, setFormValuesIn = internals.setFormValuesIn, setFormInitialValuesIn = internals.setFormInitialValuesIn, updateRecoverableShownState = internals.updateRecoverableShownState, supportUnmountClearStates = internals.supportUnmountClearStates, disableUnmountClearStates = internals.disableUnmountClearStates, enableUnmountClearStates = internals.enableUnmountClearStates, enableUnmountRemoveNode = internals.enableUnmountRemoveNode, disableUnmountRemoveNode = internals.disableUnmountRemoveNode, resetFormMessages = internals.resetFormMessages, syncFormMessages = internals.syncFormMessages, batchRunTaskQueue = internals.batchRunTaskQueue, pushTaskQueue = internals.pushTaskQueue;
    function eachArrayExchanges(prevState, currentState, eacher) {
        var _a, _b;
        var exchanged = {};
        var prevValue = prevState.value;
        var currentValue = currentState.value;
        var maxLengthValue = (prevValue === null || prevValue === void 0 ? void 0 : prevValue.length) > (currentValue === null || currentValue === void 0 ? void 0 : currentValue.length) ? prevValue : currentValue;
        var lastResults;
        shared_1.each(maxLengthValue, function (item, index) {
            var _a, _b;
            var prev = (_a = prevValue === null || prevValue === void 0 ? void 0 : prevValue[index]) === null || _a === void 0 ? void 0 : _a[field_1.ARRAY_UNIQUE_TAG];
            var current = (_b = currentValue === null || currentValue === void 0 ? void 0 : currentValue[index]) === null || _b === void 0 ? void 0 : _b[field_1.ARRAY_UNIQUE_TAG];
            if (prev === current)
                return;
            if (prev === undefined) {
                return;
            }
            if ((currentValue === null || currentValue === void 0 ? void 0 : currentValue.length) === (prevValue === null || prevValue === void 0 ? void 0 : prevValue.length)) {
                if (exchanged[prev] || exchanged[current])
                    return;
                exchanged[prev] = true;
                exchanged[current] = true;
            }
            lastResults = eacher(prev, current, lastResults);
        }, ((_a = currentState === null || currentState === void 0 ? void 0 : currentState.value) === null || _a === void 0 ? void 0 : _a.length) >= ((_b = prevState === null || prevState === void 0 ? void 0 : prevState.value) === null || _b === void 0 ? void 0 : _b.length));
    }
    function calculateMovePath(name, replace) {
        var segments = [];
        var indexes = [];
        shared_1.FormPath.parse(name).forEach(function (key) {
            if (/^\d+$/.test(key)) {
                indexes.push(segments.length);
            }
            segments.push(key);
        });
        if (indexes.length) {
            segments[indexes[indexes.length - 1]] = replace;
        }
        return segments.join('.');
    }
    function getExchangeState(state) {
        var results = __assign({}, state);
        delete results.name;
        delete results.path;
        if (results.visible === false ||
            results.unmounted === true ||
            results.mounted === false) {
            delete results.value;
            delete results.values;
        }
        delete results.mounted;
        delete results.unmounted;
        return results;
    }
    function calculateRemovedTags(prevTags, currentTags) {
        if (prevTags.length <= currentTags.length)
            return [];
        env.realRemoveTags = prevTags.reduce(function (buf, tag) {
            return currentTags.includes(tag) ? buf : buf.concat(tag);
        }, []);
        return prevTags.slice(currentTags.length - prevTags.length);
    }
    function removeArrayNodes(field, tags) {
        if (tags.length <= 0)
            return;
        var matchTag = function (node) { return function (tag) {
            return shared_1.FormPath.parse(calculateMathTag(tag)).matchAliasGroup(node.state.name, node.state.path);
        }; };
        graph.eachChildren(field.state.path, function (node) {
            if (tags.some(matchTag(node))) {
                graph.remove(node.state.path);
            }
        });
        tags.forEach(function (tag) {
            graph.select(calculateMathTag(tag), function (node) {
                graph.remove(node.state.path);
            });
        });
    }
    function calculateMathTag(tag) {
        return "*(" + tag + "," + tag + ".*)";
    }
    function exchangeState(parentPath, prevPattern, currentPattern, lastCurrentStates) {
        var currentIndex = shared_1.FormPath.transform(currentPattern, /\d+/, function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return Number(args[args.length - 1]);
        });
        var exchanged = {};
        var currentStates = {};
        graph.eachChildren(parentPath, calculateMathTag(prevPattern), function (prevField) {
            var prevPath = prevField.state.path;
            var prevState = prevField.getState(getExchangeState);
            var currentPath = calculateMovePath(prevPath, currentIndex);
            var currentState = getFieldState(currentPath, getExchangeState);
            var currentField = graph.get(currentPath);
            if (prevField) {
                prevField.setSourceState(function (state) {
                    if (currentState) {
                        Object.assign(state, currentState);
                    }
                    else {
                        Object.assign(state, getExchangeState(lastCurrentStates[prevPath]));
                    }
                    if (types_1.isField(prevField)) {
                        syncFormMessages('errors', state);
                        syncFormMessages('warnings', state);
                    }
                });
            }
            if (currentField) {
                currentStates[currentPath] = currentField.getState();
                currentField.setSourceState(function (state) {
                    Object.assign(state, prevState);
                });
            }
            exchanged[prevPath + currentPath] = true;
        });
        return currentStates;
    }
    function eachParentFields(field, callback) {
        graph.eachParent(field.state.path, function (node) {
            if (types_1.isField(node)) {
                callback(node);
            }
        });
    }
    function onFieldChange(_a) {
        var field = _a.field, path = _a.path;
        return function (published) {
            var dirtys = field.dirtys;
            if (dirtys.initialized) {
                heart.publish(types_1.LifeCycleTypes.ON_FIELD_INIT, field);
            }
            if (dirtys.value || dirtys.values) {
                var isArrayList = /array/gi.test(published.dataType);
                if (isArrayList) {
                    var prevTags = field_1.parseArrayTags(field.prevState.value);
                    var currentTags = field_1.parseArrayTags(published.value);
                    if (!shared_1.isEqual(prevTags, currentTags)) {
                        var removedTags = calculateRemovedTags(prevTags, currentTags);
                        if (prevTags.length && currentTags.length) {
                            form.batch(function () {
                                eachArrayExchanges(field.prevState, published, function (prev, current, lastResults) {
                                    if (lastResults === void 0) { lastResults = {}; }
                                    return exchangeState(path, prev, current, lastResults);
                                });
                            });
                        }
                        removeArrayNodes(field, removedTags);
                        setFormValuesIn(field.state.name, field_1.tagArrayList(field.state.value, field.state.name, true), true);
                    }
                }
                heart.publish(types_1.LifeCycleTypes.ON_FIELD_VALUE_CHANGE, field);
                eachParentFields(field, function (node) {
                    heart.publish(types_1.LifeCycleTypes.ON_FIELD_VALUE_CHANGE, node);
                });
            }
            if (dirtys.initialValue) {
                heart.publish(types_1.LifeCycleTypes.ON_FIELD_INITIAL_VALUE_CHANGE, field);
                eachParentFields(field, function (node) {
                    heart.publish(types_1.LifeCycleTypes.ON_FIELD_INITIAL_VALUE_CHANGE, node);
                });
            }
            if (dirtys.visible || dirtys.display) {
                graph.eachChildren(path, function (childState) {
                    childState.setState(function (state) {
                        if (dirtys.visible) {
                            updateRecoverableShownState(published, state, 'visible');
                        }
                        if (dirtys.display) {
                            updateRecoverableShownState(published, state, 'display');
                        }
                    }, true);
                });
            }
            if (dirtys.unmounted && published.unmounted) {
                afterUnmount(function () {
                    env.realRemoveTags = [];
                });
                heart.publish(types_1.LifeCycleTypes.ON_FIELD_UNMOUNT, field);
                if (env.unmountRemoveNode) {
                    graph.remove(field.state.path);
                }
            }
            if (dirtys.mounted && published.mounted) {
                heart.publish(types_1.LifeCycleTypes.ON_FIELD_MOUNT, field);
            }
            if (dirtys.errors) {
                syncFormMessages('errors', published);
            }
            if (dirtys.warnings) {
                syncFormMessages('warnings', published);
            }
            if (dirtys.visible ||
                dirtys.display ||
                dirtys.editable ||
                dirtys.unmounted) {
                if (dirtys.unmounted) {
                    if (supportUnmountClearStates(published.path)) {
                        resetFormMessages(published);
                    }
                }
                else {
                    resetFormMessages(published);
                }
            }
            heart.publish(types_1.LifeCycleTypes.ON_FIELD_CHANGE, field);
            return !env.hostRendering;
        };
    }
    function onVirtualFieldChange(_a) {
        var field = _a.field, path = _a.path;
        return function (published) {
            var dirtys = field.dirtys;
            if (dirtys.initialized) {
                heart.publish(types_1.LifeCycleTypes.ON_FIELD_INIT, field);
            }
            if (dirtys.visible || dirtys.display) {
                graph.eachChildren(path, function (childState) {
                    childState.setState(function (state) {
                        if (dirtys.visible) {
                            updateRecoverableShownState(published, state, 'visible');
                        }
                        if (dirtys.display) {
                            updateRecoverableShownState(published, state, 'display');
                        }
                    }, true);
                });
            }
            if (dirtys.unmounted && published.unmounted) {
                afterUnmount(function () {
                    env.realRemoveTags = [];
                });
                heart.publish(types_1.LifeCycleTypes.ON_FIELD_UNMOUNT, field);
                if (env.unmountRemoveNode) {
                    graph.remove(field.state.path);
                }
            }
            if (dirtys.mounted && published.mounted) {
                heart.publish(types_1.LifeCycleTypes.ON_FIELD_MOUNT, field);
            }
            heart.publish(types_1.LifeCycleTypes.ON_FIELD_CHANGE, field);
            return !env.hostRendering;
        };
    }
    function pickNotEmpty(v1, v2) {
        if (!shared_1.isEmpty(v1))
            return v1;
        if (!shared_1.isEmpty(v2))
            return v2;
        if (shared_1.isValid(v1))
            return v1;
        if (shared_1.isValid(v2))
            return v2;
    }
    function registerField(_a) {
        var path = _a.path, name = _a.name, value = _a.value, initialValue = _a.initialValue, required = _a.required, rules = _a.rules, editable = _a.editable, visible = _a.visible, display = _a.display, computeState = _a.computeState, dataType = _a.dataType, props = _a.props;
        var field;
        var nodePath = shared_1.FormPath.parse(path || name);
        var dataPath = getDataPath(nodePath);
        var createField = function () {
            var field = new field_1.Field({
                nodePath: nodePath,
                dataPath: dataPath,
                computeState: computeState,
                dataType: dataType,
                getValue: function (name) {
                    return getFormValuesIn(name);
                },
                supportUnmountClearStates: function (path) {
                    var _a;
                    if (!supportUnmountClearStates(path))
                        return false;
                    if (!((_a = env.realRemoveTags) === null || _a === void 0 ? void 0 : _a.length))
                        return true;
                    return env.realRemoveTags.every(function (tag) {
                        return !shared_1.FormPath.parse(calculateMathTag(tag)).match(path);
                    });
                },
                getEditable: function () {
                    return form.getState(function (state) { return state.editable; });
                },
                setValue: function (name, value) {
                    upload(function () {
                        setFormValuesIn(name, value);
                    });
                },
                setInitialValue: function (name, value) {
                    upload(function () {
                        setFormInitialValuesIn(name, value);
                    });
                },
                removeValue: function (name) {
                    if (!graph.get(nodePath))
                        return;
                    upload(function () {
                        deleteFormValuesIn(name);
                    });
                },
                getInitialValue: function (name) {
                    return getFormInitialValuesIn(name);
                },
                unControlledValueChanged: function () {
                    nextTick(function () {
                        field.dirtys = {
                            value: true,
                            values: true,
                            modified: true
                        };
                        field.dirtyCount = 3;
                        heart.publish(types_1.LifeCycleTypes.ON_FIELD_VALUE_CHANGE, field);
                        heart.publish(types_1.LifeCycleTypes.ON_FIELD_CHANGE, field);
                    });
                }
            });
            field.subscription = {
                notify: onFieldChange({ field: field, path: nodePath })
            };
            heart.publish(types_1.LifeCycleTypes.ON_FIELD_WILL_INIT, field);
            graph.appendNode(field, nodePath, dataPath);
            field.batch(function () {
                field.setState(function (state) {
                    var formValue = getFormValuesIn(state.name);
                    var formInitialValue = getFormInitialValuesIn(state.name);
                    var syncValue = pickNotEmpty(value, formValue);
                    var syncInitialValue = pickNotEmpty(initialValue, formInitialValue);
                    if (shared_1.isValid(syncInitialValue)) {
                        state.initialValue = syncInitialValue;
                    }
                    if (shared_1.isValid(syncValue)) {
                        state.value = syncValue;
                    }
                    else {
                        if (shared_1.isValid(state.initialValue)) {
                            state.value = state.initialValue;
                        }
                    }
                    if (shared_1.isValid(visible)) {
                        state.visible = visible;
                    }
                    if (shared_1.isValid(display)) {
                        state.display = display;
                    }
                    if (shared_1.isValid(props)) {
                        state.props = props;
                    }
                    if (shared_1.isValid(required)) {
                        state.required = required;
                    }
                    if (shared_1.isValid(rules)) {
                        state.rules = rules;
                    }
                    if (shared_1.isValid(editable)) {
                        state.selfEditable = editable;
                    }
                    if (shared_1.isValid(options.editable)) {
                        state.formEditable = options.editable;
                    }
                    state.initialized = true;
                });
                batchRunTaskQueue(field, nodePath);
            });
            validator.register(nodePath, function (validate) {
                var _a = field.getState(), value = _a.value, rules = _a.rules, errors = _a.errors, warnings = _a.warnings, editable = _a.editable, visible = _a.visible, unmounted = _a.unmounted, display = _a.display;
                if (editable === false ||
                    visible === false ||
                    unmounted === true ||
                    display === false ||
                    field.disabledValidate ||
                    (rules.length === 0 && errors.length === 0 && warnings.length === 0))
                    return validate(value, []);
                clearTimeout(field.validateTimer);
                field.validateTimer = setTimeout(function () {
                    field.setState(function (state) {
                        state.validating = true;
                    });
                }, 60);
                heart.publish(types_1.LifeCycleTypes.ON_FIELD_VALIDATE_START, field);
                return validate(value, rules).then(function (_a) {
                    var errors = _a.errors, warnings = _a.warnings;
                    clearTimeout(field.validateTimer);
                    return new Promise(function (resolve) {
                        field.setState(function (state) {
                            state.validating = false;
                            state.ruleErrors = errors;
                            state.ruleWarnings = warnings;
                        });
                        heart.publish(types_1.LifeCycleTypes.ON_FIELD_VALIDATE_END, field);
                        resolve({
                            errors: errors,
                            warnings: warnings
                        });
                    });
                });
            });
            return field;
        };
        if (graph.exist(nodePath)) {
            field = graph.get(nodePath);
        }
        else {
            field = createField();
        }
        return field;
    }
    function registerVirtualField(_a) {
        var name = _a.name, path = _a.path, display = _a.display, visible = _a.visible, computeState = _a.computeState, props = _a.props;
        var nodePath = shared_1.FormPath.parse(path || name);
        var dataPath = getDataPath(nodePath);
        var field;
        var createField = function () {
            var field = new virtual_field_1.VirtualField({
                nodePath: nodePath,
                dataPath: dataPath,
                computeState: computeState
            });
            field.subscription = {
                notify: onVirtualFieldChange({ field: field, path: nodePath })
            };
            heart.publish(types_1.LifeCycleTypes.ON_FIELD_WILL_INIT, field);
            graph.appendNode(field, nodePath, dataPath);
            field.batch(function () {
                field.setState(function (state) {
                    state.initialized = true;
                    state.props = props;
                    if (shared_1.isValid(visible)) {
                        state.visible = visible;
                    }
                    if (shared_1.isValid(display)) {
                        state.display = display;
                    }
                });
                batchRunTaskQueue(field, nodePath);
            });
            return field;
        };
        if (graph.exist(nodePath)) {
            field = graph.get(nodePath);
        }
        else {
            field = createField();
        }
        return field;
    }
    function getFieldState(path, callback) {
        var field = graph.select(path);
        return field && field.getState(callback);
    }
    function setFieldState(path, callback, silent) {
        if (!shared_1.isFn(callback))
            return;
        var matchCount = 0;
        var pattern = shared_1.FormPath.getPath(path);
        graph.select(pattern, function (field) {
            if (!types_1.isFormState(field)) {
                field.setState(callback, silent);
            }
            matchCount++;
        });
        if (matchCount === 0 || pattern.isWildMatchPattern) {
            pushTaskQueue(pattern, callback);
        }
    }
    function getFieldValue(path) {
        return getFieldState(path, function (state) {
            return state.value;
        });
    }
    function setFieldValue(path, value, silent) {
        setFieldState(path, function (state) {
            state.value = value;
        }, silent);
    }
    function getFieldInitialValue(path) {
        return getFieldState(path, function (state) {
            return state.initialValue;
        });
    }
    function setFieldInitialValue(path, value, silent) {
        setFieldState(path, function (state) {
            state.initialValue = value;
        }, silent);
    }
    function getFormState(callback) {
        return form.getState(callback);
    }
    function setFormState(callback, silent) {
        hostUpdate(function () {
            form.setState(callback, silent);
        });
    }
    function getFormGraph() {
        return graph.map(function (node) {
            return node.getState();
        });
    }
    function setFormGraph(nodes) {
        shared_1.each(nodes, function (node, key) {
            var nodeState;
            if (graph.exist(key)) {
                nodeState = graph.get(key);
                nodeState.setSourceState(function (state) {
                    Object.assign(state, node);
                });
            }
            else {
                if (node.displayName === 'VirtualFieldState') {
                    nodeState = registerVirtualField({
                        path: key
                    });
                    nodeState.setSourceState(function (state) {
                        Object.assign(state, node);
                    });
                }
                else if (node.displayName === 'FieldState') {
                    nodeState = registerField({
                        path: key
                    });
                    nodeState.setSourceState(function (state) {
                        Object.assign(state, node);
                    });
                }
            }
            if (nodeState) {
                nodeState.notify(form.getState());
            }
        });
    }
    function subscribe(callback) {
        return heart.subscribe(callback);
    }
    function unsubscribe(id) {
        heart.unsubscribe(id);
    }
    function notify(type, payload) {
        heart.publish(type, payload);
    }
    function submit(onSubmit) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (form.getState(function (state) { return state.submitting; }))
                    return [2, env.submittingTask];
                heart.publish(types_1.LifeCycleTypes.ON_FORM_SUBMIT_START, form);
                onSubmit = onSubmit || options.onSubmit;
                form.setState(function (state) {
                    state.submitting = true;
                });
                env.submittingTask = function () { return __awaiter(_this, void 0, void 0, function () {
                    var validated, errors, payload, values, e_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                heart.publish(types_1.LifeCycleTypes.ON_FORM_SUBMIT_VALIDATE_START, form);
                                return [4, validate('', { throwErrors: false, hostRendering: true })];
                            case 1:
                                _a.sent();
                                validated = form.getState(function (state) { return ({
                                    errors: state.errors,
                                    warnings: state.warnings
                                }); });
                                errors = validated.errors;
                                if (errors.length) {
                                    form.setState(function (state) {
                                        state.submitting = false;
                                    });
                                    heart.publish(types_1.LifeCycleTypes.ON_FORM_SUBMIT_VALIDATE_FAILED, form);
                                    heart.publish(types_1.LifeCycleTypes.ON_FORM_SUBMIT_END, form);
                                    if (shared_1.isFn(options.onValidateFailed) && !form.state.unmounted) {
                                        options.onValidateFailed(validated);
                                    }
                                    throw errors;
                                }
                                heart.publish(types_1.LifeCycleTypes.ON_FORM_SUBMIT_VALIDATE_SUCCESS, form);
                                heart.publish(types_1.LifeCycleTypes.ON_FORM_SUBMIT, form);
                                values = form.getState(function (state) { return shared_1.clone(state.values); });
                                if (!(shared_1.isFn(onSubmit) && !form.state.unmounted)) return [3, 5];
                                _a.label = 2;
                            case 2:
                                _a.trys.push([2, 4, , 5]);
                                return [4, Promise.resolve(onSubmit(values))];
                            case 3:
                                payload = _a.sent();
                                heart.publish(types_1.LifeCycleTypes.ON_FORM_ON_SUBMIT_SUCCESS, payload);
                                return [3, 5];
                            case 4:
                                e_1 = _a.sent();
                                heart.publish(types_1.LifeCycleTypes.ON_FORM_ON_SUBMIT_FAILED, e_1);
                                new Promise(function () {
                                    throw e_1;
                                });
                                return [3, 5];
                            case 5:
                                form.setState(function (state) {
                                    state.submitting = false;
                                });
                                heart.publish(types_1.LifeCycleTypes.ON_FORM_SUBMIT_END, form);
                                return [2, {
                                        values: values,
                                        validated: validated,
                                        payload: payload
                                    }];
                        }
                    });
                }); };
                return [2, env.submittingTask()];
            });
        });
    }
    function reset(props) {
        if (props === void 0) { props = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var validateResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        props = shared_1.defaults({
                            selector: '*',
                            forceClear: false,
                            validate: true,
                            clearInitialValue: false
                        }, props);
                        hostUpdate(function () {
                            graph.eachChildren('', props.selector, function (field) {
                                ;
                                field.disabledValidate = true;
                                field.setState(function (state) {
                                    state.modified = false;
                                    state.ruleErrors = [];
                                    state.ruleWarnings = [];
                                    state.effectErrors = [];
                                    state.effectWarnings = [];
                                    if (props.clearInitialValue) {
                                        state.initialValue = undefined;
                                    }
                                    if (props.forceClear || !shared_1.isValid(state.initialValue)) {
                                        if (shared_1.isArr(state.value)) {
                                            state.value = [];
                                        }
                                        else if (shared_1.isPlainObj(state.value)) {
                                            state.value = {};
                                        }
                                        else {
                                            state.value = undefined;
                                        }
                                    }
                                    else {
                                        var value = shared_1.clone(state.initialValue);
                                        if (shared_1.isArr(state.value)) {
                                            if (shared_1.isArr(value)) {
                                                state.value = value;
                                            }
                                            else {
                                                state.value = [];
                                            }
                                        }
                                        else if (shared_1.isPlainObj(state.value)) {
                                            if (shared_1.isPlainObj(value)) {
                                                state.value = value;
                                            }
                                            else {
                                                state.value = {};
                                            }
                                        }
                                        else {
                                            state.value = value;
                                        }
                                    }
                                });
                                field.disabledValidate = false;
                            });
                        });
                        if (shared_1.isFn(options.onReset) && !form.state.unmounted) {
                            options.onReset();
                        }
                        heart.publish(types_1.LifeCycleTypes.ON_FORM_RESET, form);
                        if (!props.validate) return [3, 2];
                        return [4, validate(props.selector, { throwErrors: false })];
                    case 1:
                        validateResult = _a.sent();
                        _a.label = 2;
                    case 2: return [2, validateResult];
                }
            });
        });
    }
    function validate(path, opts) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, throwErrors, hostRendering, payload, result, errors, warnings;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = opts || {}, _b = _a.throwErrors, throwErrors = _b === void 0 ? true : _b, hostRendering = _a.hostRendering;
                        if (!form.getState(function (state) { return state.validating; })) {
                            form.setSourceState(function (state) {
                                state.validating = true;
                            });
                            clearTimeout(env.validateTimer);
                            env.validateTimer = setTimeout(function () {
                                form.notify();
                            }, 60);
                        }
                        heart.publish(types_1.LifeCycleTypes.ON_FORM_VALIDATE_START, form);
                        if (graph.size > 100 && hostRendering)
                            env.hostRendering = true;
                        return [4, validator.validate(path, opts)];
                    case 1:
                        payload = _c.sent();
                        clearTimeout(env.validateTimer);
                        form.setState(function (state) {
                            state.validating = false;
                        });
                        heart.publish(types_1.LifeCycleTypes.ON_FORM_VALIDATE_END, form);
                        if (graph.size > 100 && hostRendering) {
                            heart.publish(types_1.LifeCycleTypes.ON_FORM_HOST_RENDER, form);
                            env.hostRendering = false;
                        }
                        result = {
                            errors: payload.errors.map(function (item) { return (__assign(__assign({}, item), { name: getFieldState(item.path).name })); }),
                            warnings: payload.warnings.map(function (item) { return (__assign(__assign({}, item), { name: getFieldState(item.path).name })); })
                        };
                        errors = result.errors, warnings = result.warnings;
                        if (warnings.length) {
                            shared_1.log.warn(warnings);
                        }
                        if (errors.length > 0) {
                            if (throwErrors) {
                                throw result;
                            }
                            else {
                                return [2, result];
                            }
                        }
                        else {
                            return [2, result];
                        }
                        return [2];
                }
            });
        });
    }
    function clearErrors(pattern) {
        if (pattern === void 0) { pattern = '*'; }
        hostUpdate(function () {
            graph.eachChildren('', pattern, function (field) {
                if (types_1.isField(field)) {
                    field.setState(function (state) {
                        state.ruleErrors = [];
                        state.ruleWarnings = [];
                        state.effectErrors = [];
                        state.effectWarnings = [];
                    });
                }
            });
        });
    }
    function createMutators(input) {
        var field;
        if (!types_1.isField(input)) {
            var selected = graph.select(input);
            if (selected) {
                field = selected;
            }
            else {
                throw new Error('The `createMutators` can only accept FieldState instance or FormPathPattern.');
            }
        }
        else {
            field = input;
        }
        function setValue() {
            var values = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                values[_i] = arguments[_i];
            }
            field.setState(function (state) {
                state.value = values[0];
                state.values = values;
                state.inputed = true;
            });
            heart.publish(types_1.LifeCycleTypes.ON_FIELD_INPUT_CHANGE, field);
            heart.publish(types_1.LifeCycleTypes.ON_FORM_INPUT_CHANGE, form);
        }
        function removeValue(key) {
            var nodePath = field.getSourceState(function (state) { return state.path; });
            if (shared_1.isValid(key)) {
                var childNodePath = shared_1.FormPath.parse(nodePath).concat(key);
                setFieldState(childNodePath, function (state) {
                    state.value = undefined;
                    state.values = [];
                    state.inputed = true;
                });
                deleteFormValuesIn(childNodePath);
            }
            else {
                field.setState(function (state) {
                    state.value = undefined;
                    state.values = [];
                    state.inputed = true;
                });
                deleteFormValuesIn(nodePath);
            }
            heart.publish(types_1.LifeCycleTypes.ON_FIELD_VALUE_CHANGE, field);
            heart.publish(types_1.LifeCycleTypes.ON_FIELD_INPUT_CHANGE, field);
            heart.publish(types_1.LifeCycleTypes.ON_FORM_INPUT_CHANGE, form);
        }
        function getValue() {
            return field.getState(function (state) { return state.value; });
        }
        var mutators = {
            change: function () {
                var values = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    values[_i] = arguments[_i];
                }
                setValue.apply(void 0, values);
                return values[0];
            },
            focus: function () {
                field.setState(function (state) {
                    state.active = true;
                });
            },
            blur: function () {
                field.setState(function (state) {
                    state.active = false;
                    state.visited = true;
                });
            },
            push: function (value) {
                var arr = shared_1.toArr(getValue()).concat(value);
                setValue(arr);
                return arr;
            },
            pop: function () {
                var origin = shared_1.toArr(getValue());
                var arr = origin.slice(0, origin.length - 1);
                setValue(arr);
                return arr;
            },
            insert: function (index, value) {
                var origin = shared_1.toArr(getValue());
                if (origin.length === 0) {
                    var arr_1 = [value];
                    setValue(arr_1);
                    return arr_1;
                }
                if (origin.length === index) {
                    var arr_2 = origin.concat([value]);
                    setValue(arr_2);
                    return arr_2;
                }
                var arr = origin.reduce(function (buf, item, idx) {
                    return idx === index ? buf.concat([value, item]) : buf.concat(item);
                }, []);
                setValue(arr);
                return arr;
            },
            remove: function (index) {
                var val = getValue();
                if (shared_1.isNum(index) && shared_1.isArr(val)) {
                    setValue(val.filter(function (item, idx) { return idx !== index; }));
                }
                else {
                    removeValue(index);
                }
            },
            exist: function (index) {
                var newPath = field.getSourceState(function (state) {
                    return shared_1.FormPath.parse(state.path);
                });
                var val = getValue();
                return (shared_1.isValid(index) ? newPath.concat(index) : newPath).existIn(val, newPath);
            },
            unshift: function (value) {
                return mutators.insert(0, value);
            },
            shift: function () {
                return mutators.remove(0);
            },
            swap: function ($from, $to) {
                var arr = shared_1.toArr(getValue()).slice();
                var fromItem = arr[$from];
                var toItem = arr[$to];
                arr[$from] = toItem;
                arr[$to] = fromItem;
                setValue(arr);
                return arr;
            },
            move: function ($from, $to) {
                var arr = shared_1.toArr(getValue()).slice();
                var item = arr[$from];
                arr.splice($from, 1);
                arr.splice($to, 0, item);
                setValue(arr);
                return arr;
            },
            moveUp: function (index) {
                var len = shared_1.toArr(getValue()).length;
                return mutators.move(index, index - 1 < 0 ? len - 1 : index - 1);
            },
            moveDown: function (index) {
                var len = shared_1.toArr(getValue()).length;
                return mutators.move(index, index + 1 >= len ? 0 : index + 1);
            },
            validate: function (opts) {
                return validate(field.getSourceState(function (state) { return state.path; }), __assign(__assign({}, opts), { hostRendering: false }));
            }
        };
        return mutators;
    }
    function hasChanged(target, path) {
        if (env.publishing[target ? target.path : ''] === false) {
            throw new Error('The watch function must be used synchronously in the subscribe callback.');
        }
        if (types_1.isFormState(target)) {
            return form.hasChanged(path);
        }
        else if (types_1.isFieldState(target) || types_1.isVirtualFieldState(target)) {
            var node = graph.get(target.path);
            return node && node.hasChanged(path);
        }
        else {
            throw new Error('Illegal parameter,You must pass the correct state object(FormState/FieldState/VirtualFieldState).');
        }
    }
    var formApi = {
        submit: submit,
        reset: reset,
        hasChanged: hasChanged,
        clearErrors: clearErrors,
        validate: validate,
        setFormState: setFormState,
        getFormState: getFormState,
        setFieldState: setFieldState,
        getFieldState: getFieldState,
        registerField: registerField,
        registerVirtualField: registerVirtualField,
        createMutators: createMutators,
        getFormGraph: getFormGraph,
        setFormGraph: setFormGraph,
        setFieldValue: setFieldValue,
        getFieldValue: getFieldValue,
        setFieldInitialValue: setFieldInitialValue,
        getFieldInitialValue: getFieldInitialValue,
        disableUnmountClearStates: disableUnmountClearStates,
        enableUnmountClearStates: enableUnmountClearStates,
        enableUnmountRemoveNode: enableUnmountRemoveNode,
        disableUnmountRemoveNode: disableUnmountRemoveNode,
        isHostRendering: isHostRendering,
        hostUpdate: hostUpdate,
        subscribe: subscribe,
        unsubscribe: unsubscribe,
        notify: notify
    };
    init(formApi);
    return formApi;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/core/lib/externals.js
// module id = 4644
// module chunks = 0